// TODO remove after implementing Stripe v3
(function() {
	// angular
	// 	.module('main')
	// 	.controller('StripeActionsController', StripeActionsController);

	StripeActionsController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$window',
		'$http',
		'paymentVariablesService',
		'accountService',
		'messageService',
		'stringModifierService',
		'userService',
		'stripeDataService',
		'stripeService',
		'settingsService',
		'subscriptionService'
	];

	function StripeActionsController(
		$scope,
		$rootScope,
		$location,
		$window,
		$http,
		paymentVariablesService,
		accountService,
		messageService,
		stringModifierService,
		userService,
		stripeDataService,
		stripeService,
		settingsService,
		subscriptionService
	) {
		$scope.$on('$destroy', () => {
			$scope.userObservable.unsubscribe();
		});

		$scope.init = function() {
			$scope.error = false;
			subscriptionService.subscription$.subscribe(subscription => {
				$scope.subscription = subscription;
			});
			getUser();
			$scope.subscription = angular.copy(paymentVariablesService.getPlan());
			if ($scope.subscription) {
				$scope.subscription = $scope.subscription.toUpperCase();
			}
			if (!$scope.subscription && !$rootScope.stripePK) {
				$scope.plan_class = 'btn-danger';
				$scope.plan_chosen = false;
				$scope.subscription_message = 'Please choose your subscription';
			}
		};

		function getUser() {
			$scope.userObservable = accountService.userDataObservable.subscribe(
				user => {
					if (user !== null && typeof user !== 'undefined') {
						$scope.user = JSON.parse(JSON.stringify(user));
						if (user && user.admin) return;
						const { annualPromo, monthlyPromo } = userService.subscriptionData;
						if (typeof $scope.user.subscription !== 'undefined') {
							$scope.isAnnualPromoOrDiscountEnabled =
								annualPromo && $scope.user.subscription.plan !== 'CHAMPION';
							$scope.isMonthlyPromoOrDiscountEnabled =
								monthlyPromo && $scope.user.subscription.plan !== 'CHAMPION';
						}
					}
				}
			);
		}

		function stripeSubscribeSuccessCallback(data) {
			const { errorMessage, status, completePaymentUrl } = data.data;

			if (status === 'REQUIRES_ACTION') {
				createIframeForCompleted3DSecure(completePaymentUrl);
			} else if (status === 'SUCCESS') {
				$scope.button_disable = false;
				completeStripeSubscribe();
				messageService.showToaster('i_0', 'subscription', $scope.subscription);
			} else {
				$scope.button_disable = false;
				messageService.showErrorFromBackend(
					'Whoops, something has gone wrong',
					errorMessage
				);
			}
		}

		function completeStripeSubscribe() {
			accountService.getUserWeb().subscribe(data => {
				if (data.enabled) {
					$rootScope.removeBg = 'blah';
				}
				if ($rootScope.hasSubscriptionBefore === false) {
					$window.location.assign('/subscribed');
				} else {
					$rootScope.showThanks = true;
					$rootScope.showThanksModal = true;
					$window.location.assign('/');
				}
			});
		}

		window.addEventListener('completeStripe3DSecure', event => {
			// Delete Iframe
			document.body.classList.remove('hidden-scroll');
			const iframeBody = document.getElementById('stripeIframeWrapper');
			iframeBody.classList.remove('stripeIframeWrapper');
			iframeBody.removeChild(iframeBody.childNodes[0]);

			if (event.detail.error) {
				messageService.showErrorFromBackend(
					'Whoops!',
					'We could not process your payment.'
				);
			} else {
				messageService.showToaster('i_0', 'subscription', $scope.subscription);
				completeStripeSubscribe();
			}
		});

		window.addEventListener('iframeLoaded', () => {
			$scope.button_disable = false;
			$('#cardDetailsModal').modal('hide');
			messageService.showToaster('i_0', 'stripe');
		});

		function createIframeForCompleted3DSecure(iframeLink) {
			// Create link
			const link = iframeLink.substring(22, iframeLink.length);

			// Create Iframe
			const ifrm = document.createElement('iframe');
			ifrm.style.width = '100vw';
			ifrm.style.height = '100vh';
			ifrm.style.border = 'none';
			ifrm.setAttribute('src', `${iframeLink}`);

			// Set Iframe to HTML
			const iframeBody = document.getElementById('stripeIframeWrapper');
			iframeBody.classList.add('stripeIframeWrapper');
			iframeBody.appendChild(ifrm);
			document.body.classList.add('hidden-scroll');
		}

		function stripeErrorCallback(data) {
			$scope.button_disable = false;
			switch (data.data.errorMessage) {
				case "Card rejected: Your card's security code is incorrect.":
					messageService.showToaster('e_2', 'stripe');
					break;
				case 'Card rejected: Your card was declined.':
					messageService.showToaster('e_4', 'stripe');
					break;
				case 'Card rejected: Your card has insufficient funds.':
					messageService.showToaster('e_5', 'stripe');
					break;
				case 'Card rejected: Your card has expired.':
					messageService.showToaster('e_6', 'stripe');
					break;
				case 'Card rejected: An error occurred while processing your card. Try again in a little bit.':
					messageService.showToaster('e_7', 'stripe');
					break;
				default:
					messageService.showToaster('e_0', 'general');
					break;
			}
		}

		$scope.hideBanner = function(id) {
			id = id || 'cardDetailsModal';
			const cardDetailsModal = document.getElementById(id);
			const classList = cardDetailsModal.classList;
			let max = classList.length,
				i = 0;

			for (; i < max; i++) {
				const key = classList[i];
				if (key.indexOf('show-banner-') + 1) {
					cardDetailsModal.classList.remove(key);
					i -= 1;
					max -= 1;
				}
			}

			return false;
		};

		$scope.choose = function() {
			$('#cardDetailsModal')
				.modal('hide')
				.on('hidden.bs.modal', function() {
					if ($location.path() !== '/subscription') {
						$('#subscriptionModal').modal('show');
						$(this).off('hidden.bs.modal');
					}
				});
		};

		function getKeyForNotSubscribedUserErrorCallback(error) {
			messageService.showDefaultErrorMessage(error);
		}

		function getKeyForNotSubscribedUserSuccessCallback(data) {
			if (data && data.message) {
				$rootScope.stripePK = data.message;
				Stripe.setPublishableKey($rootScope.stripePK);

				const cardData = {
					ccNum: $scope.card_number,
					cvcNum: $scope.card_cvc,
					expMonth: $scope.card_expiry_month,
					expYear: $scope.card_expiry_year
				};

				const result = stripeService.createWebStripeToken(
					data,
					cardData,
					$scope.subscription
				);

				if (result === false) {
					$scope.button_disable = false;
				} else if (result instanceof Rx.Observable) {
					result
						.finally(() => ($scope.button_disable = false))
						.subscribe(
							res => subscribeStripe(res),
							err => ($scope.button_disable = false)
						);
				} else {
					$scope.button_disable = false;
				}
			}

			function subscribeStripe(data) {
				const { stripe_token, plan } = data;
				stripeDataService
					.subscribeStripe(stripe_token, plan)
					.finally(() => ($scope.button_disable = false))
					.subscribe(
						res => stripeSubscribeSuccessCallback(res),
						err => stripeErrorCallback(err)
					);
			}
		}

		$scope.validateStripe = function() {
			$scope.button_disable = true;
			delete $scope.error;
			$scope.amount = 20;
			$scope.expires = false;
			$scope.unsibscribe_show = false;
			stripeDataService
				.getStripeUserKey()
				.subscribe(
					data => getKeyForNotSubscribedUserSuccessCallback(data),
					error => getKeyForNotSubscribedUserErrorCallback(error)
				);
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/stripeActionsController.js